export default function TikTokFlatIcon({color = '#424242', ...rest}) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0668 4.38C10.6111 3.85975 10.3599 3.19162 10.3601 2.5H8.3001V10.7667C8.28422 11.214 8.09535 11.6377 7.77328 11.9486C7.45121 12.2595 7.02107 12.4333 6.57344 12.4333C5.62677 12.4333 4.8401 11.66 4.8401 10.7C4.8401 9.55333 5.94677 8.69333 7.08677 9.04667V6.94C4.78677 6.63333 2.77344 8.42 2.77344 10.7C2.77344 12.92 4.61344 14.5 6.56677 14.5C8.6601 14.5 10.3601 12.8 10.3601 10.7V6.50667C11.1954 7.10657 12.1983 7.42843 13.2268 7.42667V5.36667C13.2268 5.36667 11.9734 5.42667 11.0668 4.38Z"
        fill={color}
      />
    </svg>
  );
}
